// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"e1fb1320","100":"3a1eb1e0","487":"97e032a8","551":"cc3f25b3","787":"b9fa4c82"}[chunkId] + ".chunk.js";
};